import React from 'react'
import { Navigate } from 'react-router-dom'
import { useCustomerAuth } from '../contexts/CustomerAuthContext'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useCustomerAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  return isAuthenticated ? children : <Navigate to="/customer/login" replace />
}

export default ProtectedRoute
